/**
 * @generated SignedSource<<697a6a80cdf2787ed416616443cf87d0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditBlockTemporarilyRestartIfFailedContentConfigInput = {
  clientMutationId?: string | null | undefined;
  configId: string;
  contentNodeId: string;
  newDaysToBlock: number;
};
export type BlockTemporarilyRestartIfFailedContentConfigForm_EditMutation$variables = {
  input: EditBlockTemporarilyRestartIfFailedContentConfigInput;
};
export type BlockTemporarilyRestartIfFailedContentConfigForm_EditMutation$data = {
  readonly Admin: {
    readonly Tree: {
      readonly editBlockTemporarilyRestartIfFailedContentConfig: {
        readonly contentNode: {
          readonly " $fragmentSpreads": FragmentRefs<"RestartIfFailedContentConfigEditor_TreeNodeFragment">;
        };
      } | null | undefined;
    };
  };
};
export type BlockTemporarilyRestartIfFailedContentConfigForm_EditMutation = {
  response: BlockTemporarilyRestartIfFailedContentConfigForm_EditMutation$data;
  variables: BlockTemporarilyRestartIfFailedContentConfigForm_EditMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BlockTemporarilyRestartIfFailedContentConfigForm_EditMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "EditBlockTemporarilyRestartIfFailedContentConfigPayload",
                "kind": "LinkedField",
                "name": "editBlockTemporarilyRestartIfFailedContentConfig",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNode",
                    "kind": "LinkedField",
                    "name": "contentNode",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "RestartIfFailedContentConfigEditor_TreeNodeFragment"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BlockTemporarilyRestartIfFailedContentConfigForm_EditMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "EditBlockTemporarilyRestartIfFailedContentConfigPayload",
                "kind": "LinkedField",
                "name": "editBlockTemporarilyRestartIfFailedContentConfig",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNode",
                    "kind": "LinkedField",
                    "name": "contentNode",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "typeDefinition",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "restartIfFailedConfigs",
                                "plural": true,
                                "selections": [
                                  (v3/*: any*/),
                                  (v2/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "configType",
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isRestartIfFailedContentConfig"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "daysToBlock",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "BlockTemporarilyRestartIfFailedContentConfig",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "maximumTries",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "BlockPermanentlyRestartIfFailedContentConfig",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "ContentTypeDefinition",
                            "abstractKey": "__isContentTypeDefinition"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8300178be8605399b17c47bd4d8b3da1",
    "id": null,
    "metadata": {},
    "name": "BlockTemporarilyRestartIfFailedContentConfigForm_EditMutation",
    "operationKind": "mutation",
    "text": "mutation BlockTemporarilyRestartIfFailedContentConfigForm_EditMutation(\n  $input: EditBlockTemporarilyRestartIfFailedContentConfigInput!\n) {\n  Admin {\n    Tree {\n      editBlockTemporarilyRestartIfFailedContentConfig(input: $input) {\n        contentNode {\n          ...RestartIfFailedContentConfigEditor_TreeNodeFragment\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment BlockPermanentlyRestartIfFailedContentConfigForm_BlockPermanentlyRestartIfFailedContentConfigFragment on BlockPermanentlyRestartIfFailedContentConfig {\n  id\n  configType\n  maximumTries\n}\n\nfragment BlockPermanentlyRestartIfFailedContentConfigForm_TreeNodeFragment on TreeNode {\n  id\n}\n\nfragment BlockTemporarilyRestartIfFailedContentConfigForm_BlockTemporarilyRestartIfFailedContentConfigFragment on BlockTemporarilyRestartIfFailedContentConfig {\n  id\n  configType\n  daysToBlock\n}\n\nfragment BlockTemporarilyRestartIfFailedContentConfigForm_TreeNodeFragment on TreeNode {\n  id\n}\n\nfragment ProjectExtendRestartIfFailedContentConfigEditor_RestartIfFailedContentConfigFragment on RestartIfFailedContentConfig {\n  __isRestartIfFailedContentConfig: __typename\n  id\n  configType\n}\n\nfragment ProjectExtendRestartIfFailedContentConfigEditor_TreeNodeFragment on TreeNode {\n  id\n  typeDefinition {\n    __typename\n    ... on ContentTypeDefinition {\n      __isContentTypeDefinition: __typename\n      restartIfFailedConfigs {\n        __typename\n        id\n        configType\n      }\n    }\n  }\n}\n\nfragment RestartIfFailedContentConfigEditor_TreeNodeFragment on TreeNode {\n  id\n  typeDefinition {\n    __typename\n    ... on ContentTypeDefinition {\n      __isContentTypeDefinition: __typename\n      restartIfFailedConfigs {\n        __typename\n        id\n        configType\n        ... on BlockTemporarilyRestartIfFailedContentConfig {\n          daysToBlock\n        }\n        ... on BlockPermanentlyRestartIfFailedContentConfig {\n          maximumTries\n        }\n        ...BlockPermanentlyRestartIfFailedContentConfigForm_BlockPermanentlyRestartIfFailedContentConfigFragment\n        ...BlockTemporarilyRestartIfFailedContentConfigForm_BlockTemporarilyRestartIfFailedContentConfigFragment\n        ...ProjectExtendRestartIfFailedContentConfigEditor_RestartIfFailedContentConfigFragment\n      }\n    }\n  }\n  ...BlockTemporarilyRestartIfFailedContentConfigForm_TreeNodeFragment\n  ...BlockPermanentlyRestartIfFailedContentConfigForm_TreeNodeFragment\n  ...ProjectExtendRestartIfFailedContentConfigEditor_TreeNodeFragment\n}\n"
  }
};
})();

(node as any).hash = "5a5e0be338f614f4085cc1bee311deeb";

export default node;
